import React from 'react';
import ReactEcharts from "echarts-for-react";
import utils from "utils";
import { Empty } from 'antd';


const chartOptions = {
    title: {
        text: ''
    },
    legend: {
        type: 'scroll',
        orient: 'vertical',
        right: 10,
        top: 20,
        bottom: 20,
        icon: "pin"
    },
    tooltip: {

    },
    radar: {
        radius: "100%",
        indicator: [
        ]
    },
    series: []
}

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: chartOptions,
            data: this.props.data || [],
            isNoData: true,
            
        };
        this.chart = React.createRef()
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.data !== prevState.data) 
          return { 
            data: nextProps.data,
            };
        else return null;
    }
    generateData(data, keys) {
      let finalData = [];
        data.forEach(m => {
            let obj = {}, values = [];
            keys.forEach(id => {
                if(m.chart && m.chart.length)
                {this.setState({isNoData: false,})}
                m.chart.forEach(n => {
                    if (id == n.chart_id) {
                        
                        values.push(n.chart_score);
                        obj.name = utils.FormatDate(m.appointment_date_time, "DATE_TIME_3");
                        obj.value = values;
                    };
                });
            });

            finalData.push(obj);
        })
        return finalData;

    }

    generateIndicators(data) {
        let keys = [], indicator = [];
        data.forEach(m => {
            m.chart.forEach(n => {
                if (keys.indexOf(n.chart_id) == -1) {
                    keys.push(n.chart_id);
                    indicator.push({
                        name: n.title,
                        max: 10
                    })
                }
            })
        });
        
        return { indicator, keys };
    }

    getChartOptions() {
        let { options, data = [] } = this.state;
        let { indicator, keys } = this.generateIndicators(data) || {};
        let series = {
            name: 'Brief Psychotherapeutic Intake',
            type: 'radar',
            areaStyle: {},
            data: this.generateData(data, keys)
        }
        
      
        options = { ...options, series, radar: { indicator }, legend: { ...options.legend, show: this.props?.legend ? false : this.state.isNoData} }
        return options
    }

    componentDidMount() {
        this.setState({
            options: this.getChartOptions()
        })
        
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.data !== this.state.data) {
              this.setState({
                  options: this.getChartOptions()
              })
        }
    }
    render() {
        return (
            <div className="therapy-intake-chart-wrapper-container">
                {!this.state.isNoData ? <ReactEcharts option={this.state.options} ref={this.chart} /> || null :
                    <div className='chart-noData-card'>
                        <div>
                            <Empty description={"No Data"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        </div>
                    </div>}
            </div>
        );
    }
}
